export class DesiredDatePrecautionsResult {
    precaution = "";
    entryPrecaution = "";
}
